/* eslint-disable no-undef */
// @ts-nocheck

import { phoneFormatter } from 'merchant/services/Helper.service';

const keysToConvert = ['Product ID', 'Product Variant Id', 'product_id', 'variant_id', 'product id', 'variant id'];
let commonAnalyticsData;
const createBody = (data?) => {
  return {
    Tag: 'GoKwik',
    Products: JSON.stringify(convertSpecificKeysToStrings(commonAnalyticsData?.products)),
    Currency: commonAnalyticsData?.currency,
    'Promo Code': commonAnalyticsData?.coupon || '',
    'Cart Total Price': commonAnalyticsData?.cart_after_discount,
    ...commonAnalyticsData?.marketingData,
    ...data,
  };
};
const mappedKey = {
  products: 'items',
  'product id': 'item_id',
  'product name': 'item_name',
  'product price': 'price',
  'product quantity': 'quantity',
  'product variant id': 'item_list_id',
  'product url': 'destination_page_URL',
  'promo code': 'coupon',
  total: 'value',
  'cart total price': 'value',
  'mobile number': 'phone',
  'first name': 'first_name',
  'last name': 'last_name',
  'full address': 'Address',
  'shipping method': 'shipping_tier',
  'payment method': 'payment_type',
  'discount name': 'coupon',
  'campaign id': 'promotion_id',
  'discount price': 'discount',
  'payment mode': 'payment_type',
  amount: 'value',
  'variant name': 'item_variant',
  'variant id': 'item_variant_id',
  shipping: 'shipping_tier',
  'product title': 'item_name',
  'order id': 'transaction_id',
  'landing page': 'landing_page',
  'origin referrer': 'origin_referrer',
  'utm source': 'utm_source',
  'utm medium': 'utm_medium',
  'utm campaign': 'utm_campaign',
  'utm term': 'utm_term',
  'utm content': 'utm_content',
};

const replacedItems = (obj) => {
  const entries = Object.keys(obj).map((key) => {
    const newKey = mappedKey[key.toLowerCase()] || key;
    return { [newKey]: obj[key] };
  });
  return Object.assign({}, ...entries);
};

const pushCleverTap = (eventData, products) => {
  products = convertSpecificKeysToStrings(products);
  if (eventData?.analyticsPixelObj?.clevertap?.split_product_array_to_multiple_events) {
    eventData?.data?.Products && delete eventData.data.Products;
    eventData?.data['Products Name'] && delete eventData?.data['Products Name'];
    products &&
      products.map((itm) => {
        clevertap.event.push(eventData.eventName, replacedItems({ ...eventData.data, ...itm }));
      });
  } else {
    clevertap.event.push(eventData.eventName, eventData.data);
  }
};

export const callCleverTap = (eventName, data) => {
  data.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'phoneNumber') {
    cleverTapPhoneNumber(data);
  } else if (eventName === 'mobileAddedGK') {
    cleverTapMobileGK(data);
  } else if (eventName === 'pinCode') {
    cleverTapPincode(data);
  } else if (eventName === 'paymentMethod') {
    clevertapPaymentMethod(data);
  } else if (eventName === 'paymentCompleted') {
    cleverTapPaymentCompleted(data);
  } else if (eventName === 'userAddress') {
    cleverTapUserAddress(data);
  } else if (eventName === 'userAddressDetail') {
    cleverTapUserAddressDetailed(data);
  } else if (eventName === 'checkoutStarted') {
    clevertapCheckoutStarted(data);
  } else if (eventName === 'coupon_applied_success_gk' || eventName === 'coupon_applied_failed_gk') {
    cleverTapDiscountEvent(eventName, data);
  }
};

const cleverTapDiscountEvent = (eventName, data) => {
  let dataObj = {
    eventName: eventName,
    analyticsPixelObj: data.analyticsPixelObj,
    data: createBody({
      'Mobile Number': `+91${data.phoneNumber}`,
      'First Name': data?.userAddress?.firstname,
      'Last Name': data?.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Promo Code': data?.evt?.coupon_code,
      amount_saved: data?.evt?.amount_saved,
      checkout_step: data?.evt?.checkout_step?.split(' ')[0].trim() || '',
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      Identity:
        data.analyticsPixelObj?.clevertap?.value === 'email'
          ? data.userAddress?.email
          : data.analyticsPixelObj?.clevertap?.value === 'phone'
            ? phoneFormatter(data.userAddress?.phone, data.analyticsPixelObj?.clevertap)
            : '',
      'Abandoned URL': data.abcURL,
    }),
  };
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const cleverTapPhoneNumber = (data) => {
  const phoneNumber = `${data.evt === null || data.evt === void 0 ? void 0 : data.evt.phoneNumber}`;
  let dataObj = {
    type: 'userLogin',
    data: {
      Site: {
        Phone: `+91${phoneNumber}`,
        'MSG-email': true,
        'MSG-push': true,
        'MSG-sms': true,
        'MSG-whatsapp': true, // Enable WhatsApp notifications
        ...((!data?.analyticsPixelObj?.clevertap || data?.analyticsPixelObj?.clevertap?.value === 'phone') && {
          Identity: phoneFormatter(phoneNumber, data?.analyticsPixelObj?.clevertap),
        }),
      },
    },
  };
  clevertap.onUserLogin.push(dataObj.data);
};

const cleverTapMobileGK = (data) => {
  let dataObj = {
    eventName: 'Mobile_Added_GK',
    data: {
      Tag: 'GoKwik',
      Products: JSON.stringify(convertSpecificKeysToStrings(data.commonAnalyticsData?.products)),
      Phone: `+91${data.evt?.phoneNumber}`,
      Currency: data.commonAnalyticsData?.currency,
      'Promo Code': data.commonAnalyticsData.coupon || '',
      Total: data.commonAnalyticsData?.cart_after_discount,
      Address: '',
      'Total Quantity': data.commonAnalyticsData?.total_quantity,
      Email: '',
      'Products Name': data.commonAnalyticsData?.product_name_array.join(','),
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Abandoned URL': data.abcURL,
      ABC_sms: data.abcURL + `&ch=clevert&src=sms`,
      ABC_mail: data.abcURL + `&ch=clevert&src=mail`,
      ABC_wa: data.abcURL + `&ch=clevert&src=wa`,
      ABC_limechat: data.abcURL + `&ch=clevert&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=clevert&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=clevert&src=guphsup`,
    },
  };
  window.location.origin.includes('levi') &&
    clevertap.addMultiValuesForKey('item_id', data.commonAnalyticsData?.pidArr);
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const cleverTapPincode = (data) => {
  let dataObj = {
    eventName: 'PIN_Code_Added_GK',
    data: createBody({
      Pincode: data.evt.pincode,
    }),
  };
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const clevertapPaymentMethod = (data) => {
  let dataObj = {
    eventName: 'Payment_Method_Selected_GK',
    data: createBody({
      'Mobile Number': `+91${data.phoneNumber}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.evt.paymentMethod,
    }),
  };
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const cleverTapPaymentCompleted = (data) => {
  let dataObj = {
    eventName: 'GK_Charged',
    data: {
      'Image url': data?.commonAnalyticsData?.imgUrlArr.join(','),
      'Discount name': data?.commonAnalyticsData?.coupon || '',
      Price: data?.commonAnalyticsData?.cart_after_discount,
      'Product Name': data?.commonAnalyticsData?.product_name_array?.join(','),
      'Campaign id': '',
      'Charged ID': data?.orderName,
      'Discount Price': data.discountAmount,
      'Payment Mode': data?.paymentMethod,
      Amount: data?.commonAnalyticsData?.cart_after_discount?.toString(),
      Currency: data?.commonAnalyticsData?.currency,
      Quantity: data?.commonAnalyticsData?.total_quantity?.toString(),
      'Product Price': '',
      'Variant Name': data?.commonAnalyticsData?.product_name_array?.join(','),
      'Variant Id': '',
      Shipping: data?.shippingMethod || 'Standard',
      'Product Title': data?.commonAnalyticsData?.product_name_array.join(','),
      'Product Id': convertSpecificKeysToStrings(data?.commonAnalyticsData?.pidArr).join(','),
      'Order Id': data?.orderName,
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
    },
  };
  if (data?.analyticsPixelObj?.clevertap?.send_charged_event) {
    dataObj['eventName'] = 'Charged';
    dataObj.data = {
      cart_session_token: data.cart.token,
      order_confirmation_url: data.thankYouPageUrl,
      total_item_price: +data.cart.original_total_price / 100,
      total_price: +data.cart.original_total_price / 100,
      total_payable: +data.finalPayablePrice,
      currency: 'INR',
      amount: +data.finalPayablePrice,
      Items: data.cart?.items?.map((item) => {
        let itemData = convertSpecificKeysToStrings({
          product_id: item.product_id,
          title: item.title,
          product_type: item.product_type,
          variant_id: item.variant_id,
          quantity: item.quantity,
          price: item.line_price / 100,
          unit_price: item.line_price / 100,
          sku: item.sku,
          image_url: item.featured_image?.url || item.image,
        });
        if (item.options_with_values) {
          item.options_with_values.forEach((option) => {
            option.name?.toLowerCase() !== 'title' && (itemData[option.name] = option.value);
          });
        }
        return itemData;
      }),
      email: data.userAddress.email,
      phone: data.phoneNumber,
      'customer first name': data.userAddress.firstname,
      'customer last name': data.userAddress.lastname,
      'Charged ID': data.orderName,
      Source: 'Gokwik',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
    };
  }

  if (window.location.origin.includes('levi')) {
    dataObj['eventName'] = 'Charged';
    dataObj.data = levisChargedEvent(data);
    clevertap.removeMultiValuesForKey('item_id', data.commonAnalyticsData?.pidArr);
  }

  if (!window.location.origin.includes('snitch') && !window.location.origin.includes('sandbox-plus'))
    pushCleverTap(dataObj, data.commonAnalyticsData.products);
};

const cleverTapUserAddress = (data) => {
  const analyticsPixelObj = data?.analyticsPixelObj;
  let ctObj = {
    type: 'userLogin',
    data: {
      Site: {
        Name: `${data.evt?.userAddress?.firstname} ${data.evt?.userAddress?.lastname}`,
        Phone: `+91${data.evt?.userAddress?.phone}`,
        Identity:
          analyticsPixelObj?.clevertap?.value === 'email'
            ? data.evt.userAddress?.email
            : analyticsPixelObj?.clevertap?.value === 'phone'
              ? phoneFormatter(data.evt.userAddress?.phone, analyticsPixelObj?.clevertap)
              : '',
        Email: data.evt?.userAddress?.email,
        'MSG-email': true,
        'MSG-push': true,
        'MSG-sms': true,
        'MSG-whatsapp': true,
      },
    },
  };
  clevertap.onUserLogin.push(ctObj.data);
  let dataObj = {
    eventName: data.eventName,
    data: createBody({
      'Mobile Number': `+91${data.evt?.userAddress?.phone}`,
      'First Name': data.evt?.userAddress?.firstname,
      'Last Name': data.evt?.userAddress?.lastname,
      Email: data.evt?.userAddress?.email,
      'Full Address': data.evt?.userAddress?.address,
      City: data.evt?.userAddress?.city,
      State: data.evt?.userAddress?.state,
      Pincode: data.evt?.userAddress?.pincode,
      'Address Type': data.evt?.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod,
      'Abandoned URL': `${data.merchantUrl}?mrid=${data.request_id}`,
      ABC_sms: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=sms`,
      ABC_mail: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=mail`,
      ABC_wa: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=wa`,
      ABC_limechat: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=limechat`,
      ABC_zoko: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=zoko`,
      ABC_gupshup: `${data.merchantUrl}?mrid=${data.request_id}&ch=clevert&src=guphsup`,
    }),
  };
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const cleverTapUserAddressDetailed = (data) => {
  const analyticsPixelObj = data?.analyticsPixelObj;
  let ctObj = {
    type: 'userLogin',
    data: {
      Site: {
        Name: `${data.evt.userAddress?.firstname} ${data.evt.userAddress?.lastname}`,
        Phone: `+91${data.evt.userAddress?.phone}`,
        Identity:
          analyticsPixelObj?.clevertap?.value === 'email'
            ? data.evt.userAddress?.email
            : analyticsPixelObj?.clevertap?.value === 'phone'
              ? phoneFormatter(data.evt.userAddress?.phone, analyticsPixelObj?.clevertap)
              : '',
        Email: data.evt.userAddress?.email,
        'MSG-email': true,
        'MSG-push': true,
        'MSG-sms': true,
        'MSG-whatsapp': true,
      },
    },
  };
  clevertap.onUserLogin.push(ctObj.data);

  let dataObj = {
    eventName: 'Address_Selected_GK',
    data: createBody({
      'Mobile Number': `+91${data.evt.userAddress?.phone}`,
      'First Name': data.evt.userAddress?.firstname,
      'Last Name': data.evt.userAddress?.lastname,
      Email: data.evt.userAddress?.email,
      'Full Address': data.evt.userAddress?.address,
      City: data.evt.userAddress?.city,
      State: data.evt.userAddress?.state,
      Pincode: data.evt.userAddress?.pincode,
      'Address Type': data.evt.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod,
      'Abandoned URL': `${location.origin}?mrid=${commonAnalyticsData.request_id}`,
      ABC_sms: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=sms`,
      ABC_mail: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=mail`,
      ABC_wa: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=wa`,
      ABC_zoko: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=zoko`,
      ABC_limechat: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=limechat`,
      ABC_gupshup: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=clevert&src=gupshup`,
    }),
  };
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

const levisChargedEvent = (data) => {
  return {
    cart_session_token: data.cart.token,
    order_confirmation_url: data.thankYouPageUrl,
    destination_page_URL: data.thankYouPageUrl,
    price: +data.cart.original_total_price / 100,
    value: +data.finalPayablePrice,
    currency: 'INR',
    Items: data.cart?.items?.map((item) => {
      let itemData = {
        item_id: item.product_id,
        item_name: item.title,
        product_type: item.product_type,
        item_list_id: item.variant_id,
        quantity: item.quantity,
        price: item.line_price / 100,
        unit_price: item.line_price / 100,
        sku: item.sku,
        image_url: item.featured_image?.url || item.image,
        item_category: item?.item_category || 'NA',
        item_category2: item?.item_category2 || 'NA',
        item_category3: item?.item_category3 || 'NA',
        item_category4: item?.item_category4 || 'NA',
        item_category5: item?.item_category5 || 'NA',
      };
      if (item.options_with_values) {
        item.options_with_values.forEach((option) => {
          itemData[option.name] = option.value;
        });
      }
      return itemData;
    }),
    email: data.userAddress.email,
    phone: data.phoneNumber,
    first_name: data.userAddress.firstname,
    last_name: data.userAddress.lastname,
    transaction_id: data.orderName,
    Source: 'Gokwik',
    shipping: data.shippingMethod,
    payment_type: data.paymentMethod,
    Address: data.userAddress.address,
    coupon: data.commonAnalyticsData.coupon,
    landing_page: data.commonAnalyticsData?.marketingData?.['Landing Page'],
    origin_referrer: data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
    utm_source: data.commonAnalyticsData?.marketingData?.['Utm Source'],
    utm_medium: data.commonAnalyticsData?.marketingData?.['Utm Medium'],
    utm_campaign: data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
    utm_term: data.commonAnalyticsData?.marketingData?.['Utm Term'],
    utm_content: data.commonAnalyticsData?.marketingData?.['Utm Content'],
  };
};

const clevertapCheckoutStarted = (data) => {
  let dataObj = {
    eventName: 'Started_Checkout_GK',
    data: {
      Tag: 'GoKwik',
      Products: JSON.stringify(data.commonAnalyticsData?.products),
      Currency: data.commonAnalyticsData?.currency,
      'Promo Code': data.commonAnalyticsData.coupon || '',
      Total: data.commonAnalyticsData?.cart_after_discount,
      'Total Quantity': data.commonAnalyticsData?.total_quantity,
      'Products Name': data.commonAnalyticsData?.product_name_array.join(','),
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
    },
  };
  window.location.origin.includes('levi') &&
    clevertap.addMultiValuesForKey('item_id', data.commonAnalyticsData?.pidArr);
  pushCleverTap(dataObj, data.commonAnalyticsData?.products);
};

function convertSpecificKeysToStrings(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertSpecificKeysToStrings(item));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        if (keysToConvert.includes(key) && typeof value !== 'string') {
          return [key, value.toString()];
        }
        return [key, convertSpecificKeysToStrings(value)];
      })
    );
  } else {
    return obj;
  }
}
